import Routes from './Route';

export interface AppConfigInterface {
  baseApiUrl: string;
  routes: typeof Routes;
  elementsPerPage: number;
  reactAppVersion: string,
}

const AppConfig: AppConfigInterface = {
  baseApiUrl: process.env.REACT_APP_API_URL,
  reactAppVersion: process.env.REACT_APP_VERSION,
  routes: Routes,
  elementsPerPage: 10,
};

export default AppConfig;
